import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDYiXRW72kLlzGQd8YTIfzdHyBWS-7AXt8',
  authDomain: 'parkingappexpo.firebaseapp.com',
  projectId: 'parkingappexpo',
  storageBucket: 'parkingappexpo.firebasestorage.app',
  messagingSenderId: '854606762470',
  appId: '1:854606762470:web:11ab0150b52831c990627',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);

export default app; 